export const mixinComments = {
    data() {
        return {
            idComment: '',
            isReply: false,
            text: '',
            oldValue: '',
            isNeedToRefresh: false,
        }
    },
    methods: {
        async submitComment(comment) {
            this.savingComment = true
            await this.$api[this.apiName]
                .createComment({
                    [this.idName]: this.currentId,
                    comment,
                    files: this.files,
                    usersForNotifications: this.usersForNotifications || null
                })
                .then((data) => {
                    this.savingComment = false;
                    if (typeof this.getHistory === 'function') {
                        this.getHistory()
                    }
                    if (typeof this.fetchComments === 'function') {
                        this.fetchComments()
                    }

                    this.$emit("commentSubmitted", true);
                });
        },
        addFiles(files) {
            this.files = files
        },
        replyComment(item) {
            this.scrollToSubmitForm();
            setTimeout(() => {
                this.isReply = true;
                this.idComment = item.id;
                this.text = item.comment;
            }, 500)
        },
        setReplyComment(params) {
            this.savingComment = true;
            this.$api[this.apiName]
                .createComment({
                    [this.idName]: this.currentId,
                    parent_comment_id: params.idComment,
                    comment: params.comment,
                    bookmarked: params.bookmarked ? params.bookmarked : false,
                    files: this.files,
                    usersForNotifications: this.usersForNotifications
                })
                .then((data) => {
                    this.savingComment = false;
                    if (typeof this.getHistory === 'function') {
                        this.getHistory()
                    }
                    if (typeof this.fetchComments === 'function') {
                        this.fetchComments()
                    }
                    this.cancelReplyOrEdit();
                })
        },
        editComment(item) {
            this.scrollToSubmitForm();
            this.idComment = item.id;
            this.oldValue = item.comment;
        },
        setEditComment(params) {
            this.$api[this.apiName].editComment(params.idComment, params.comment)
                .then(() => {
                    if (typeof this.getHistory === 'function') {
                        this.getHistory()
                    }
                    if (typeof this.fetchComments === 'function') {
                        this.fetchComments()
                    }
                    this.cancelReplyOrEdit();
                })
                .catch(() => {
                    // Ошибку (например, истекло время на редактирование) показывает axios-интерцептор,
                    // здесь выходим из режима редактирования и обновляем список
                    if (typeof this.getHistory === 'function') {
                        this.getHistory()
                    }
                    if (typeof this.fetchComments === 'function') {
                        this.fetchComments()
                    }
                    this.cancelReplyOrEdit();
                });
        },
        cancelReplyOrEdit() {
            this.idComment = '';
            this.isReply = false;
            this.text = '';
            this.oldValue = '';
            this.isNeedToRefresh = true;
        },
        refreshed() {
            this.isNeedToRefresh = false;
        },
        scrollToRepliedComment(id) {
            document.getElementById(id).scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            })
            return false;
        },
        scrollToSubmitForm() {
            document.getElementById('comment-submit-form').scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            })
            return false;
        },
    }
}
